export default __webpack_public_path__ + "static/media/chat10.4c22c4fc.png";